import React from 'react';
import Button from '../Button/Button';
import { useSelectable } from '.';

const SelectableToggle = () => {
    const {isSelecting, toggleIsSelecting} = useSelectable();

    return <Button theme={isSelecting ? 'primary' : 'light'}
        icon="Check"
        onClick={toggleIsSelecting}
        zeroMargin
    />
}

export default SelectableToggle;
